module.exports = __webpack_public_path__ + "img/img45.f4fb1549.png";